import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { CoreConfigService } from "@core/services/config.service";
import { AuthService } from "../../services/auth/auth.service";
import Swal from "sweetalert2";
import { ProviderService } from "app/modules/provider/services/provider/provider.service";
import { HotelServices } from "app/modules/hotels/services/hotel/hotel.service";
import { User } from "../../../../core/models/user";
import { AdminUserService } from "../../../main/services/adminUserService/admin-user.service";
import { NotificationsService } from "app/layout/components/navbar/navbar-notification/notifications.service";
import { UsersService } from "app/modules/main/services/users/users.service";
import { jwtDecode } from "jwt-decode";

@Component({
  selector: "app-auth-page",
  templateUrl: "./auth-page.component.html",
  styleUrls: ["./auth-page.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AuthPageComponent implements OnInit {
  //  Public
  public coreConfig: any;
  public loginForm: FormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = "";
  public passwordTextType: boolean;
  user: any;

  email: string;
  password: string;

  // Private
  private _unsubscribeAll: Subject<any>;
  idHotel: any;
  userId: any;
  data: any = [];
  rooms: any = [];
  notis: any = [];
  socket: any;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _AuthService: AuthService,
    private _ProviderService: ProviderService,
    private _HotelService: HotelServices,
    private _adminService: AdminUserService,
    private NotificationsService: NotificationsService,
    private usersService: UsersService
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  created: number;

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    const loginData = {
      email: this.loginForm.value.username,
      password: this.loginForm.value.password,
    };
    let resData: any;
    try {
      this._AuthService.login(loginData).subscribe(
        (res) => {
          console.log(res);
          resData = res;
          console.log("resData: ", resData);
          if (!res) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Correo o contraseña incorrectos",
              confirmButtonText: "Ok",
            });
          }
          const token = jwtDecode(resData.token);
          const user = token["user"];

          if (user.status === 0) {
            return Swal.fire({
              icon: "error",
              title: "Usuario Desactivado",
              text: "Activa tu Cuenta Mediante el Correo Enviado O comunícate con Servicio al Cliente.",
              confirmButtonText: "Ok",
            });
          } else if (user.status === 1) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Bienvenido",
              text: "Has iniciado sesión correctamente",
              showConfirmButton: false,
              timer: 1000,
            });
            localStorage.setItem("user_token", resData.token);
            localStorage.setItem("user_id", user.user_id);
            localStorage.setItem("user_type_id", user.user_type_id);
            localStorage.setItem("user_role_id", user.user_role_id);
            localStorage.setItem("user_status", user.status);
            localStorage.setItem("user_name", user.name);
            localStorage.setItem("user_last_name", user.last_name);
            if (user.user_type_id == 2){
              this._AuthService.getEstablishmentByUserId(user.user_id).subscribe(
                (res: any) => {
                  console.log(res);
                  localStorage.setItem("establishment_id", res.establishment_id);
                  localStorage.setItem("establishment_name", res.name);
                  this._coreConfigService.updateUser();
                }
              );
            } 
            this._coreConfigService.updateUser();
            this._router.navigate(["/negociation/demand"]);
          }
        },
        (err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Correo o contraseña incorrectos",
            confirmButtonText: "Ok",
          });
          console.log(err);
        }
      );
    } catch (error) {
      console.log("error: ", error);
    }
  }

  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      username: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required],
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams["returnUrl"] || "/";

    // Subscribe to config changes
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.coreConfig = config;
      });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  registerRouter() {
    this._router.navigate(["/provider-register"]);
  }

  loginProviderRouter() {
    this._router.navigate(["/provider"]);
  }
}
